import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: 'A AAPEQ é para iniciantes?',
    answer: 'Não. A AAPEQ é exclusiva para artistas atuantes.'
  },
  {
    question: 'Preciso comprovar atuação?',
    answer: 'Sim. Vídeos, fotos, certificados, declarações de escolas, grupos, academias ou registros profissionais são obrigatórios.'
  },
  {
    question: 'Tem curso 100% online?',
    answer: 'Não. Todos os processos exigem encontros presenciais, com suporte online complementar.'
  },
  {
    question: 'Em quanto tempo vou ver resultados?',
    answer: 'Os primeiros ajustes de foco, energia e presença costumam ser percebidos já nos primeiros encontros, desde que o artista aplique as técnicas e se envolva nos processos.'
  },
  {
    question: 'Quais áreas vocês atendem?',
    answer: 'Atores, músicos, cantores, DJs, dançarinos, atletas, diretores, professores, treinadores e estudantes (módulo específico).'
  },
  {
    question: 'Quem conduz os processos?',
    answer: 'Profissionais com experiência em arte, desenvolvimento humano, energia, telepatia aplicada e alta performance, integrando referências clássicas com métodos avançados.'
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-black text-[#262364] mb-6">
            Perguntas Frequentes
          </h2>
          <p className="text-base text-gray-700 max-w-2xl mx-auto leading-relaxed">
            Tire suas dúvidas sobre a AAPEQ e entenda melhor como funciona nosso processo de seleção e desenvolvimento artístico.
          </p>
        </div>

        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden transition-all hover:shadow-md"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-5 sm:px-8 py-5 flex items-center justify-between gap-4 text-left cursor-pointer"
              >
                <h3 className="text-base sm:text-lg font-bold text-[#262364] flex-1">
                  {item.question}
                </h3>
                <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full bg-[#F05954] transition-transform ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-xl text-white"></i>
                </div>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 sm:px-8 pb-6">
                  <p className="text-base text-gray-700 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-600 mb-4">
            Ainda tem dúvidas? Entre em contato conosco!
          </p>
          <a
            href="https://wa.me/5511999999999?text=Tenho%20dúvidas%20sobre%20a%20AAPEQ"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#262364] hover:text-[#F05954] transition-colors font-semibold cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            <span>Fale conosco no WhatsApp</span>
          </a>
        </div>
      </div>
    </section>
  );
}
